import React, { useEffect } from 'react';
import { type DispatchProps, type Props } from './types';
import { AccessRequestCapabilityType } from '../../state/confluence/access-request-capabilities/types';
import View from './view';

const CrossJoin = ({
	connectedSpace,
	accessRequestCapability,
	origin,
	collaborators,
	triggerConfluenceAccessRequestCheck,
	triggerFetchConfluenceCollaborators,
	cloudId,
	isCrossJoinProjectExperimentEnabled = false,
	crossJoinProjectExperimentCohort = 'not-enrolled',
}: Props & DispatchProps) => {
	useEffect(() => {
		triggerConfluenceAccessRequestCheck();
	}, [triggerConfluenceAccessRequestCheck]);

	useEffect(() => {
		if (
			accessRequestCapability &&
			[
				AccessRequestCapabilityType.REQUEST_ACCESS,
				AccessRequestCapabilityType.DIRECT_ACCESS,
			].includes(accessRequestCapability)
		) {
			// fetch collaborators only for the RA / join product scenario
			triggerFetchConfluenceCollaborators();
		}
	}, [accessRequestCapability, triggerFetchConfluenceCollaborators]);

	// still loading
	if (!accessRequestCapability) {
		return null;
	}

	return (
		<View
			accessRequestCapability={accessRequestCapability}
			connectedSpace={connectedSpace}
			origin={origin}
			collaborators={collaborators}
			cloudId={cloudId}
			spaceKey={connectedSpace.projectSpaceKey}
			parentPageId={connectedSpace.projectPageLinkedId}
			isCrossJoinProjectExperimentEnabled={isCrossJoinProjectExperimentEnabled}
			crossJoinProjectExperimentCohort={crossJoinProjectExperimentCohort}
		/>
	);
};

export default CrossJoin;
